import { normalizeString } from '@/components/Form/helper/cdpPrefillHelper';

const PERSONALIZED_SALUTATIONS = new Set(['herr', 'frau', 'Herr', 'Frau']);

export function hasPersonalizedName(salutation?: string, lastname?: string): boolean {
  const normalizedSalutation = normalizeString(salutation);
  const normalizedLastname = normalizeString(lastname);

  return PERSONALIZED_SALUTATIONS.has(normalizedSalutation) && normalizedLastname.length > 0;
}
